import logger from './logger';
import { yleAnalyticsAccounts } from './properties/frontend';

export function initializeAnalytics(): void {
  if (typeof window === 'undefined') {
    throw new Error('Analytics may only be initialized in browser');
  }
  if (!window.yleAnalytics) {
    logger.warn('window.yleAnalytics is not defined');
    return;
  }
  const accounts = yleAnalyticsAccounts();
  logger.debug(
    `Initializing yle-analytics-sdk with accounts: ${accounts
      .map((a) => a.type)
      .join(', ')}`
  );
  try {
    window.yleAnalytics.accounts.addAccounts(accounts);
  } catch (e) {
    logger.warn({ error: e }, 'Initializing analytics failed with error');
  }
}

export function trackPage(): void {
  if (typeof window === 'undefined') {
    throw new Error('trackPage may only be used in browser');
  }

  (async () => {
    if (!window.yleAnalytics) {
      logger.warn('window.yleAnalytics is not defined');
      return;
    }

    logger.debug('Sending track page analytics');

    try {
      await window.yleAnalytics.trackPage();
    } catch (e) {
      logger.error(e);
    }
  })();
}
